import React, { useState } from 'react';
import { Navbar, Dropdown } from 'react-bootstrap';
import { CircleQuestionMark, Mail, Info, Star, LogOut } from 'lucide-react';
import logo from '../assets/img/uni-logo.svg';
import help from '../assets/icon/help_svgrepo.svg';
import { Link } from 'react-router-dom';
import './Topbar.css';
import { useMsal } from '@azure/msal-react';
import { useAzureData } from '../context/AzureContext';
import Feedback from './Feedback';
import { UnileverButton } from './ButtonComponents';

const Topbar: React.FC = () => {
  const { graphData, apiToken } = useAzureData();
  const profileImage = sessionStorage.getItem('profileImageUrl');
  const { instance } = useMsal();
  const [showFeedback, setShowFeedback] = useState(false);

  const logout = () => {
    const accounts = instance.getAllAccounts();
    instance.logoutRedirect({ account: accounts[0] });
  };

  const handleFeedbackClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowFeedback(true);
  };

  const closeFeedback = () => {
    setShowFeedback(false);
  };

  return (
    <Navbar className="topbar" variant="dark" expand="lg" fixed="top">
      {/* Brand Section */}
      <Link to="/" className="topbar-left">
        <img alt="Unilever Logo" src={logo} className="logo-img" />
        <div className="brand-text">AI Foundation</div>
      </Link>

      {/* Icons & Actions */}
      <div className="icon-section">
        {/* Help Dropdown */}
        <Dropdown align="end">
          <Dropdown.Toggle as="button" className="help-info-btn">
            <CircleQuestionMark size={24} strokeWidth={2} className="help-info-icon" />
            Help & Info
          </Dropdown.Toggle>

          <Dropdown.Menu className="help-dropdown-menu">
            <Dropdown.Item
              className="d-flex align-items-center"
              href="https://unilever.sharepoint.com/sites/AI/SitePages/AI%20Foundation.aspx"
              target="_blank">
              <img src={help} alt="Help" className="dropdown-icon" />
              Help
            </Dropdown.Item>

            <Dropdown.Item
              className="d-flex align-items-center text-secondary"
              role="button"
              onClick={handleFeedbackClick}>
              <Star size={20} strokeWidth={1.5} style={{ marginRight: '8px' }} />
              Feedback
            </Dropdown.Item>

            <Dropdown.Item
              className="d-flex align-items-center"
              href="mailto:dl_unilever_ai_foundation@unilever.com">
              <Mail size={20} strokeWidth={1.5} style={{ marginRight: '8px' }} />
              Contact Us
            </Dropdown.Item>

            <Dropdown.Item
              className="d-flex align-items-center"
              href="https://unilever.sharepoint.com/sites/AI/SitePages/AI%20Foundation.aspx"
              target="_blank">
              <Info size={20} strokeWidth={1.5} style={{ marginRight: '8px' }} />
              About Us
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        {/* User Dropdown */}
        <Dropdown align="end">
          <Dropdown.Toggle
            variant="light"
            id="dropdown-user"
            className="border-0 bg-transparent p-0 user-dropdown-toggle">
            {profileImage ? (
              <img src={profileImage} alt="User" className="user-profile-img" />
            ) : (
              <i className="bi bi-person-circle user-icon" style={{ color: '#0a1f44' }}></i>
            )}
          </Dropdown.Toggle>

          <Dropdown.Menu className="user-dropdown-menu">
            <Dropdown.ItemText className="user-dropdown-name text-start w-100">
              {graphData?.['displayName']}
            </Dropdown.ItemText>
            <Dropdown.ItemText className="user-dropdown-email text-start w-100">
              {graphData?.['mail'] || graphData?.['userPrincipalName']}
            </Dropdown.ItemText>
            <Dropdown.Divider className="user-dropdown-divider" />
            <Dropdown.Item className="user-dropdown-email text-start w-100">
              <UnileverButton
                buttonAction={() => {
                  navigator.clipboard.writeText(apiToken || '');
                }}>
                {' '}
                Copy Access Token
              </UnileverButton>
            </Dropdown.Item>
            <Dropdown.Divider className="user-dropdown-divider" />
            {/* <Dropdown.Item
              className="user-dropdown-element text-start w-100"
              onClick={() => navigator.clipboard.writeText(apiToken || 'not available')}>
              Copy Token
            </Dropdown.Item> */}
            {/* <Dropdown.Divider className="user-dropdown-divider" /> */}
            <Dropdown.Item
              className="user-dropdown-logout d-flex align-items-center"
              onClick={() => logout()}>
              <LogOut size={20} strokeWidth={2} style={{ marginRight: '8px' }} />
              Log out
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* Feedback Modal */}
      <Feedback show={showFeedback} closeModal={closeFeedback} />
    </Navbar>
  );
};

export default Topbar;
